export const GB_FEATURES = {
  EXP_BREEDER_SEARCH_UPDATES: 'exp_breeder_search_updates'
};
